import React, { useMemo, memo } from "react";
import TaskItem from "./TaskItem";

const TaskList = memo(
  ({ tasks, projects, onEditTask, onDeleteTask, onUpdateTask }) => {
    // Memoize project lookup to avoid recalculating on every render
    const projectMap = useMemo(() => {
      const map = new Map();
      projects.forEach((project) => {
        map.set(project.id, project);
      });
      return map;
    }, [projects]);

    const getProjectName = (projectId) => {
      const project = projectMap.get(projectId);
      return project ? project.name : "Unknown Project";
    };

    const getProjectColor = (projectId) => {
      const project = projectMap.get(projectId);
      return project ? project.color : "#97feed";
    };

    if (tasks.length === 0) {
      return (
        <div className="task-list empty">
          <p>No tasks found. Create a project and add some tasks!</p>
        </div>
      );
    }

    return (
      <div className="task-list">
        {tasks.map((task) => (
          <TaskItem
            key={task.id}
            task={task}
            projectName={getProjectName(task.projectId)}
            projectColor={getProjectColor(task.projectId)}
            onDelete={onDeleteTask}
            onUpdate={onUpdateTask}
            projects={projects}
          />
        ))}
      </div>
    );
  }
);

TaskList.displayName = "TaskList";

export default TaskList;
